// Paths exactly as declared under `Route::prefix('student')` in the backend's
// routes/api.php. studentApi.js mounts its baseURL at `${baseURL}/api`, so
// the full URL for e.g. ATTENDANCE.GET is `${baseURL}/api/student/attendance`.
// If the backend nests this group under an additional version prefix,
// adjust studentApi.js's baseURL rather than every path here.
export const STUDENT_ENDPOINTS = {
  AUTH: {
    SEND_OTP: "student/otp",
    VERIFY_OTP: "student/verify",
    SEND_LOGIN_OTP: "student/send-login-otp",
    VERIFY_LOGIN_OTP: "student/verify-login-otp",
    LOGOUT: "student/logout",
    STORE_FCM_TOKEN: "student/store-token",
  },
  PROFILE: {
    GET_DETAILS: "student/details",
    GET_ENROLLED_SESSIONS: "student/enrolled-sessions",
    GET_FEATURES: "student/features", // append `/${organizationId}`
    EDIT_REQUEST: "student/edit-request",
    UPLOAD_PHOTO: "student/upload-photo",
    EDIT_REQUEST_STATUS: "student/edit-request-status", // append `/${studentId}`
  },
  SIBLING: {
    GENERATE_OTP: "student/sibling/generate-otp",
    VERIFY_OTP_AND_ADD: "student/sibling/verify-otp-and-add-sibling",
    GET: "student/sibling",
  },
  ATTENDANCE: {
    GET: "student/attendance",
    GET_SUMMARY: "student/attendance-summary",
  },
  TIME_TABLE: {
    GET: "student/time-table",
    GET_UPLOADED: "student/upload-timetable",
  },
  SYLLABUS: {
    GET: "student/syllabus",
  },
  HOMEWORK: {
    GET: "student/homework",
  },
  LEAVE: {
    GET: "student/leave",
    APPLY: "student/leave",
  },
  CIRCULAR: {
    GET: "student/circular",
  },
  FAQ: {
    GET: "student/faq",
  },
  WORD_OF_THE_DAY: {
    GET: "student/word-of-the-day",
  },
  NEWSLETTER: {
    GET: "student/newsletter",
  },
  EVENT: {
    GET: "student/event",
  },
  NOTIFICATION: {
    GET: "student/notifications",
    GET_TYPES: "student/notifications/types",
    MARK_READ: "student/notifications/mark-read",
  },
  LESSON_PLAN: {
    GET: "student/lesson-plans",
    GET_DETAIL: "student/lesson-plans", // append `/${id}`
  },
  // Confirmed against the shipping mobile app's API client (2026-10-22):
  // this is a thin proxy to the external apeejay.news WordPress site's own
  // categories endpoint — getNewsroomPosts (in StudentNewsroomService) calls
  // that external site directly for the posts within a category since no
  // backend proxy for posts-by-category was provided.
  NEWSROOM: {
    GET_CATEGORIES: "student/news/room",
  },
  // Confirmed against the shipping mobile app's API client (2026-10-22):
  // nested one level under the `student` prefix as `student/parent/...`,
  // not `student/appointments` — gated server-side by the
  // `parent.app.feature:appointment` middleware, so these may 403/404 for
  // an organization that hasn't enabled the feature.
  APPOINTMENT: {
    GET: "student/parent/appointments",
    CREATE: "student/parent/appointments",
    CONFIRM: "student/parent/appointments", // append `/${id}/confirm`
    CANCEL: "student/parent/appointments", // append `/${id}/cancel`
    RESCHEDULE: "student/parent/appointments", // append `/${id}/reschedule`
  },
  MEETING_WITH_TYPES: {
    GET: "student/meeting-with-types-list",
  },
  // Added 2026-10-27: dedicated student-portal result download route,
  // authenticated with the student's own token like every other student/*
  // endpoint. Replaces the old `result-view` static-token service, which
  // had no CORS headers at all and used a long-expired hardcoded JWT.
  RESULT: {
    DOWNLOAD: "student/download-reportcard", // append `/${sessionId}/${termId}/0` — send_s3 is always 0 for in-app viewing/download
  },
};
